import signup from "./signup";
import router from "../../router";

export default function () {
    return router({signup});
}
